var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDelayShip24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.012 20.615a.6.6 0 1 1 .6-1.04A8.746 8.746 0 1 0 4.452 7.56l.632-.119a.6.6 0 1 1 .22 1.18l-2.129.398a.6.6 0 0 1-.7-.48L2.077 6.41a.6.6 0 1 1 1.18-.22l.146.785C6.164 2.258 12.22.651 16.959 3.387c4.757 2.747 6.387 8.83 3.64 13.587s-8.83 6.387-13.587 3.64"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12 5.9a.6.6 0 0 1 .6.6v5.068l2.59.864a.6.6 0 1 1-.38 1.138l-3-1a.6.6 0 0 1-.41-.57V6.5a.6.6 0 0 1 .6-.6"
})));
export { SvgDelayShip24 as ReactComponent };